import * as React from "react";
import Svg, { SvgProps, G, Path, Defs, ClipPath,Mask } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path fill="#FFFFFF" d="M0 0h24v24H0z" />
    <Path fill="#FFFFFF" d="M-280-62H80v800h-360z" />
    <G clipPath="url(#a)">
      <Path
        fill="#000"
        d="M6.248 19c-.377 0-.694-.129-.952-.386a1.293 1.293 0 0 1-.386-.951V6.16c0-.377.129-.694.386-.951a1.3 1.3 0 0 1 .957-.386H8.18V3.18h.689v1.644h6.352V3.18h.596v1.644h1.927c.38 0 .699.129.956.386.258.257.386.574.386.951v11.502c0 .377-.128.694-.386.951a1.293 1.293 0 0 1-.951.386H6.248Zm.005-.596h11.49a.714.714 0 0 0 .514-.233.714.714 0 0 0 .234-.514V9.892H5.506v7.765c0 .187.078.358.233.514a.714.714 0 0 0 .514.233Zm-.747-9.108H18.49v-3.13a.714.714 0 0 0-.234-.513.714.714 0 0 0-.514-.234H6.254a.714.714 0 0 0-.514.234.714.714 0 0 0-.233.514v3.13Z"
      />
      <Mask
        id="b"
        width={13}
        height={13}
        x={11.861}
        y={12}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M11.861 12h13v13h-13z" />
        <Path d="m18.43 21.27-.207-.193a60.109 60.109 0 0 1-1.656-1.567c-.436-.433-.78-.812-1.032-1.137-.252-.326-.427-.619-.526-.88a2.194 2.194 0 0 1-.148-.781c0-.482.165-.888.495-1.218.33-.33.735-.494 1.217-.494.364 0 .704.099 1.02.296.316.198.595.49.838.875.246-.385.526-.677.84-.875A1.873 1.873 0 0 1 20.29 15c.482 0 .888.164 1.217.493.33.33.494.735.494 1.217 0 .261-.049.523-.147.783-.099.261-.274.554-.526.879-.251.325-.594.704-1.029 1.138a51.1 51.1 0 0 1-1.659 1.567l-.208.193Z" />
      </Mask>
      <Path
        fill="#000"
        d="m18.43 21.27-.207-.193a60.109 60.109 0 0 1-1.656-1.567c-.436-.433-.78-.812-1.032-1.137-.252-.326-.427-.619-.526-.88a2.194 2.194 0 0 1-.148-.781c0-.482.165-.888.495-1.218.33-.33.735-.494 1.217-.494.364 0 .704.099 1.02.296.316.198.595.49.838.875.246-.385.526-.677.84-.875A1.873 1.873 0 0 1 20.29 15c.482 0 .888.164 1.217.493.33.33.494.735.494 1.217 0 .261-.049.523-.147.783-.099.261-.274.554-.526.879-.251.325-.594.704-1.029 1.138a51.1 51.1 0 0 1-1.659 1.567l-.208.193Z"
      />
      <Path
        stroke="#FDFBF9"
        strokeWidth={5.471}
        d="m18.43 21.27-.207-.193a60.109 60.109 0 0 1-1.656-1.567c-.436-.433-.78-.812-1.032-1.137-.252-.326-.427-.619-.526-.88a2.194 2.194 0 0 1-.148-.781c0-.482.165-.888.495-1.218.33-.33.735-.494 1.217-.494.364 0 .704.099 1.02.296.316.198.595.49.838.875.246-.385.526-.677.84-.875A1.873 1.873 0 0 1 20.29 15c.482 0 .888.164 1.217.493.33.33.494.735.494 1.217 0 .261-.049.523-.147.783-.099.261-.274.554-.526.879-.251.325-.594.704-1.029 1.138a51.1 51.1 0 0 1-1.659 1.567l-.208.193Z"
        mask="url(#b)"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SvgComponent;